import { lazy } from 'react';

export const CreateLiquidWallet = lazy(() => import('./CreateLiquidWallet.component'));
